import styled from 'styled-components';

import { SummaryFieldTitle, SummaryFieldValue } from '../../shared/styled';

export const Heading = styled.h3`
  width: 100%;
  text-align: center;
  font: var(--font-headings-heading-3);
  margin: 0 0 var(--sizes-50) 0;
  padding: 0;
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SummaryCardContainer = styled.div`
  border-radius: var(--sizes-30);
  border: 1px solid var(--color-gray-20);
  background: var(--color-grayscale-white);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0;
  width: 100%;
`;

export const SummaryCardTitle = styled.div`
  width: 100%;
  font: var(--font-regular-14pt-semibold);
  padding: var(--sizes-40) var(--sizes-60);
  text-align: left;
  border-bottom: 1px solid var(--color-gray-20);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const SummaryCardBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--sizes-30);
  padding: var(--sizes-40) var(--sizes-60) var(--sizes-60);
`;

export const SummaryCardBodyRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: var(--sizes-60);
`;

export const SummaryCardRowTitle = styled(SummaryFieldTitle)`
  flex-grow: 1;
  width: 50%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--sizes-10);
`;

export const SummaryCardRowValue = styled(SummaryFieldValue)`
  flex-grow: 1;
  width: 50%;
`;

export const AppliedFiltersWrapper = styled(SummaryCardRowValue)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
`;

export const OnlineDetailsImagePreviewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
